import { render } from "./app-form-customer.vue?vue&type=template&id=c47cb3c4&scoped=true"
import script from "./app-form-customer.vue?vue&type=script&lang=js"
export * from "./app-form-customer.vue?vue&type=script&lang=js"

import "./app-form-customer.vue?vue&type=style&index=0&id=c47cb3c4&scoped=true&lang=css"

import exportComponent from "/var/www/payje-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c47cb3c4"]])

export default __exports__